/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, IconButton, Paper, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Add, Delete } from "@mui/icons-material";
import AddNewAlert from "../Alerts/AddNewAlert";
import {
  AlertModel,
  AlertPerItemsModel,
  ProductModel,
  ProductStockModel,
} from "../../Utils/Models";
import { postData } from "../../Services/postData";
import { filterFields, getTextColorBasedOnBg } from "../../Utils/Utils";
import { modelTypesForAlerts } from "../../Utils/AutocompleteUtils";
import { deleteData } from "../../Services/deleteData";

type AlertsForProductsProps = {
  product: ProductModel;
};
export default function AlertsForProducts(props: AlertsForProductsProps) {
  const { product } = props;
  //to reset the autocomplete after adding a new inventory
  const [workaround, setWorkaround] = useState(null);
  const [alerts, setAlerts] = useState<AlertModel[]>([]);
  const [alertsForProduct, setAlertsForProduct] = useState<
    AlertPerItemsModel[]
  >([]);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const excludedFields = [
    "_id",
    "inventory",
    "isNew",
    "percentageVAT",
    "createdAt",
    "updatedAt",
    "deleted_at",
    "__v",
  ];
  const propertyOptions = filterFields(new ProductStockModel(), excludedFields);
  const ruleOptions: { label: string; value: string }[] = [
    {
      label: "< (mai mic)",
      value: "<",
    },
    {
      label: "<= (mai mic sau egal)",
      value: "<=",
    },
    {
      label: "> (mai mare)",
      value: ">",
    },
    {
      label: ">= (mai mare sau egal)",
      value: ">=",
    },
    {
      label: "= (egal)",
      value: "=",
    },
  ];

  /**
   *
   */
  useEffect(() => {
    getAlerts();
    getAlertsForProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   */
  useEffect(() => {
    if (workaround) setWorkaround(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertsForProduct]);

  /**
   *
   */
  function getAlerts() {
    getData(urlEnum.alerts).then((response) => {
      if (response && response.data && response.data.result)
        setAlerts(response.data.result);
    });
  }

  /**
   *
   */
  function getAlertsForProduct() {
    getData(`${urlEnum.alertsPerItems}/${product._id}`).then((response) => {
      if (response && response.data && response.data.result) {
        setAlertsForProduct(response.data.result);
      }
    });
  }
  /**
   *
   * @param param0
   * @returns
   */
  function AddButtonForAutocomplete({ children, ...other }: any) {
    return (
      <Paper {...other}>
        <div style={{ position: "absolute", right: -28, top: -35 }}>
          <IconButton
            onMouseDown={(e) => {
              e.preventDefault();
              setOpenAlertModal(true);
            }}
            style={{
              background: "#18cc9c",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              padding: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Add style={{ verticalAlign: "middle" }} />
          </IconButton>
        </div>
        {children}
      </Paper>
    );
  }

  /**
   *
   * @param alert
   */
  async function addNewAlert(alert: AlertModel) {
    const response = await postData(urlEnum.alerts, alert);
    if (response && response.data && response.data.result) {
      getAlerts();
    }
    setOpenAlertModal(false);
  }

  /**
   *
   * @param e
   * @param newValue
   * @returns
   */
  async function saveAlertForProduct(e: any, newValue: any) {
    setWorkaround(newValue);
    if (!newValue) return;
    const alertPerItems = new AlertPerItemsModel();
    alertPerItems.alert = newValue;
    alertPerItems.model = product;
    alertPerItems.modelType = modelTypesForAlerts.products;
    const response = await postData(urlEnum.alertsPerItems, alertPerItems);
    if (response && response.data && response.data.result) {
      getAlertsForProduct();
    }
  }

  /**
   *
   * @param alertForProduct
   */
  async function deleteAlertForProduct(alertForProduct: AlertPerItemsModel) {
    const response = await deleteData(
      `${urlEnum.alertsPerItems}/${alertForProduct._id}`
    );
    if (response && response.data && response.data.result) {
      getAlertsForProduct();
    }
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Autocomplete
        options={alerts}
        getOptionLabel={(option: any) => option.name}
        value={workaround}
        onChange={(event, newValue) => {
          saveAlertForProduct(event, newValue);
        }}
        PaperComponent={({ children, ...other }) =>
          AddButtonForAutocomplete({
            children,
            fieldName: "type",
            ...other,
          })
        }
        getOptionDisabled={(option) =>
          alertsForProduct &&
          !!alertsForProduct.find(
            (element: any) => element.alert._id === option._id
          )
        }
        renderInput={(params) => (
          <TextField {...params} label={Vocabulary.alert} size="small" />
        )}
      />
      <div>
        {alertsForProduct.map(
          (alertForProduct: AlertPerItemsModel, index: number) => (
            <div
              key={alertForProduct._id}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  flex: 1,
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: alertForProduct.alert.color,
                  padding: "0px 10px",
                  borderRadius: 5,
                  color: getTextColorBasedOnBg(alertForProduct.alert.color),
                }}
              >
                <p style={{ flex: 1 }}> {alertForProduct.alert.name}</p>
                <p>
                  {alertForProduct.alert.property
                    ? Vocabulary[alertForProduct.alert.property]
                    : alertForProduct.alert.property}
                </p>
                &nbsp;&nbsp;
                <p> {alertForProduct.alert.rule}</p>
                &nbsp;&nbsp;
                <p> {alertForProduct.alert.threshold}</p>
              </div>
              <Delete
                style={{
                  marginLeft: 20,
                  marginTop: 20,
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => deleteAlertForProduct(alertForProduct)}
              />
            </div>
          )
        )}
      </div>
      {openAlertModal ? (
        <AddNewAlert
          editAlert={null}
          open={openAlertModal}
          propertyOptions={propertyOptions}
          ruleOptions={ruleOptions}
          onClose={() => setOpenAlertModal(false)}
          addOrUpdateAlert={(alert: AlertModel) => addNewAlert(alert)}
        />
      ) : null}
    </div>
  );
}
